export const BASE_API_URL = `https://api.redbricksadvisor.com/api`;
export const APPLICATION = `Web`;
export const APPLICATION_TYPE = `EmployeeManagementSystem`;
// dev | design | QA | production
export const ENVIRONMENT = `production`;
export const AppTokenKey = "Redbricks";
export const UserDetails = "UserDetails";
export const LocalAppEncryptKey = "Redbricksadvisor95749";
